export enum VisaDocumentType {
  FR = 'FR',
  AU = 'AU',
  MX_EXHIBITOR = 'MX_EXHIBITOR',
  ENGB_EXHIBITOR = 'ENGB_EXHIBITOR',
  ENGB_VISITOR = 'ENGB_VISITOR'
}
